import {
  CLMS_HRL_CropTypes_S2023_R10m_json_color_list,
  CLMS_HRL_ForestTypes_S2023_R10m_json_color_list,
  landCoverCropTypeEvaluator,
  landCoverForestTypeEvaluator,
  landCoverGenericTypeDescription,
  WorldCover2021_json_color_list,
  worldCoverTypeDescription,
  worldCoverTypeEvaluator,
} from "../../wms/landCoverWms";
import { HazardIdEnum, LocationRiskAssessment, PageTabs, PolicyDetails } from "../hazardIdEnum";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

export const coverTypeHazardList = (): Hazard[] => [
  {
    cysId: HazardIdEnum.LandCoverCropTypeEur2023,
    name: "Land cover - Crop type 2023 (EUR)",
    // permissions: ["CYS_ENVR_LANDC_EUR_CLMS_V2023"],
    permissions: [PermissionIdEnum.LandCoverCropTypeEur2023],
    colorRange: CLMS_HRL_CropTypes_S2023_R10m_json_color_list(),
    description: landCoverGenericTypeDescription("Crop"),
    label: "Land cover - Crop type 2023 (EUR)",

    evaluateByFrontend: landCoverCropTypeEvaluator,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.LandCoverForestTypeEur2023,
    name: "Land cover - Forest type 2023 (EUR)",
    // permissions: ["CYS_ENVR_LANDF_EUR_CLMS_V2023"],
    permissions: [PermissionIdEnum.LandCoverForestTypeEur2023],
    colorRange: CLMS_HRL_ForestTypes_S2023_R10m_json_color_list(),
    description: landCoverGenericTypeDescription("Forest"),
    label: "Land cover - Forest type 2023 (EUR)",
    evaluateByFrontend: landCoverForestTypeEvaluator,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },

  {
    cysId: HazardIdEnum.WorldCover2021,
    name: "World cover classes 2021 (Global)",
    // permissions: ["CYS_ENVR_LANDC_WRL_ESA_V2021"],
    permissions: [PermissionIdEnum.WorldCover2021],
    colorRange: WorldCover2021_json_color_list(),
    description: worldCoverTypeDescription(),
    label: "World cover classes 2021 (Global)",
    evaluateByFrontend: worldCoverTypeEvaluator,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.socioEnvironmentTab,
  },
];
